import { useEffect } from "react";
import { SportProvider } from "../../models/interfaces/SportProvider";
import { FeaturedEventView } from "./featuredEvent/FeaturedEventView";
import { User } from "../../models/interfaces/User";
import { useResolverList } from "../../helpers/useResolverList";
import { LoadStatus } from "../../components/containers/LoadStatus";

import { FeaturedEventPlaceholder } from './featuredEvent/FeaturedEventPlaceholder';

interface Props {
    sportProvider: SportProvider;
    user?: User;
    onFirstEventId?: (id: string | undefined) => void;
}

export function FeaturedEventsView({ sportProvider, user, onFirstEventId }: Props) {
    const events = useResolverList(sportProvider.fanResolverProviders.featuredEventProvider, 'events');
    useEffect(() => { onFirstEventId?.(events.firstId); }, [events.firstId, onFirstEventId]);
    return <>
        <LoadStatus {...events} label="tournaments" quietLoading />
        {!events.loading && !events.error && events.items.length === 0 && <h5>No featured tournaments</h5>}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {(events.slots || (events.loading || events.error ? [{ id: 'placeholder-1' }, { id: 'placeholder-2' }] : [])).map(slot =>
                <div key={slot.id}>{slot.item
                    ? <FeaturedEventView sportProvider={sportProvider} event={slot.item} user={user} />
                    : <FeaturedEventPlaceholder loading={events.loading} />}</div>)}
        </div>
    </>;
}
